export default {
    STATE_NEW: 'new',
    STATE_PROCESSING: 'processing',
    STATE_COMPLETE: 'complete',
    STATE_CLOSED: 'closed',
    STATE_CANCELED: 'canceled',
    STATE_HOLDED: 'holded',
    STATE_PAYMENT_REVIEW: 'payment_review',

    STATUS_NOT_SYNC: 'not_sync',
    STATUS_CANCELED: 'canceled',
    STATUS_CLOSED: 'closed',
    STATUS_COMPLETE: 'complete',
    STATUS_FRAUD: 'fraud',
    STATUS_HOLDED: 'holded',
    STATUS_PAYMENT_REVIEW: 'payment_review',
    STATUS_PENDING: 'pending',
    STATUS_PENDING_PAYMENT: 'pending_payment',
    STATUS_PROCESSING: 'processing',

    /**
     * Payment status
     */
    PAYMENT_STATUS_PAID: 'Paid',
    PAYMENT_STATUS_UNPAID: 'Unpaid',
    PAYMENT_STATUS_PARTIAL_PAID: 'Partially Paid',
    PAYMENT_STATUS_VOID: 'Void',
}



// WEBPACK FOOTER //
// ./src/view/constant/order/StatusConstant.js